import { type UseQueryResult, useQuery } from 'react-query';
import { SupportContactService } from '../../services/wealthlane-customer-services/services/SupportContactService';
import { Wealthlane_CustomerService_Dtos_SupportContact_SupportContactDto } from '../../services/wealthlane-customer-services/models/Wealthlane_CustomerService_Dtos_SupportContact_SupportContactDto';

const useGetSupportContacts = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  hasManageAlertSubscription: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_SupportContact_SupportContactDto[] | undefined,
  unknown
> => {
  const supportContacts = useQuery(
    ['getSupportContacts'],
    async () => {
      return await handleRequest(
        SupportContactService.getApiCustomerApiAppSupportContactSupportContacts()
      );
    },
    {
      enabled: hasManageAlertSubscription,
      cacheTime: 1000 * 60 * 5,
    }
  );

  return supportContacts;
};

export default useGetSupportContacts;
